import clientApi from './clientApi';

// Client-portal recurring orders API (templates + occurrences).
export const recurringOrdersService = {
  async listTemplates() {
    const res = await clientApi.get('/client-portal/recurring-orders');
    return res.data;
  },

  async getTemplate(id) {
    const res = await clientApi.get(`/client-portal/recurring-orders/${id}`);
    return res.data;
  },

  async createTemplate(payload) {
    const res = await clientApi.post('/client-portal/recurring-orders', payload);
    return res.data;
  },

  async updateTemplate(id, payload) {
    const res = await clientApi.put(`/client-portal/recurring-orders/${id}`, payload);
    return res.data;
  },

  async pauseTemplate(id) {
    const res = await clientApi.post(`/client-portal/recurring-orders/${id}/pause`);
    return res.data;
  },

  async resumeTemplate(id) {
    const res = await clientApi.post(`/client-portal/recurring-orders/${id}/resume`);
    return res.data;
  },

  async cancelTemplate(id) {
    const res = await clientApi.post(`/client-portal/recurring-orders/${id}/cancel`);
    return res.data;
  },

  async listOccurrences(status = null) {
    const params = status ? { status } : {};
    const res = await clientApi.get('/client-portal/recurring-orders/occurrences', { params });
    return res.data;
  },

  async getOccurrence(id) {
    const res = await clientApi.get(`/client-portal/recurring-orders/occurrences/${id}`);
    return res.data;
  },

  async confirmOccurrence(id, overrides = null) {
    const body = overrides ? { overrides } : {};
    const res = await clientApi.post(`/client-portal/recurring-orders/occurrences/${id}/confirm`, body);
    return res.data;
  },

  async skipOccurrence(id) {
    const res = await clientApi.post(`/client-portal/recurring-orders/occurrences/${id}/skip`);
    return res.data;
  },
};
